import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const CONFLUENCE_SPACE_CLIENT_ID: ClientId = client('confluence-space');
